<script setup lang="ts">
    const { referralLink } = useReferral();
    const { $tracker } = useNuxtApp();

    defineProps({
        collapsed: {
            type: Boolean,
            required: false,
        },
        isBurger: {
            type: Boolean,
            default: false,
        },
    });

    const trackReferralClick = () => {
        $tracker.track('sidebar_referralprogram_click');
    };
</script>

<template>
    <a
        class="relative flex transition-all rounded-md pl-2 pr-3 py-[6px] w-full md:hover:bg-branding-rich-black"
        :class="[collapsed ? 'w-10' : 'w-full']"
        :href="referralLink"
        target="_blank"
        @click="trackReferralClick"
    >
        <div
            class="text-xl gap-3 flex flex-row items-center w-full min-w-0"
            :class="isBurger ? 'text-black' : 'text-white'"
        >
            <i
                class="fa-jelly fa-gift text-base w-[26px] text-center flex-shrink-0"
                aria-hidden="true"
            />
            <transition
                enter-active-class="transition-all duration-100 ease-out"
                enter-from-class="opacity-0"
                enter-to-class="opacity-100"
                leave-active-class="transition-all duration-100 ease-out delay-150"
                leave-from-class="opacity-100"
                leave-to-class="opacity-0"
            >
                <span
                    v-if="!collapsed"
                    class="text-sm font-inter text-nowrap max-md:font-medium truncate"
                >
                    {{ $t('modules.referral') }}
                </span>
            </transition>
            <span
                v-if="!collapsed"
                class="bg-branding-brand-yellow text-branding-rich-black px-1.5 py-0.5 rounded-full font-medium text-[10px] leading-tight font-inter ml-auto flex-shrink-0 uppercase"
            >
                {{ $t('app.common.badges_info.new') }}
            </span>
        </div>
    </a>
</template>
